module.exports = __webpack_public_path__ + "static/media/support-icon.653c1967.svg";